import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Components
import Header from '../components/Header/Header';
import Sidebar from '../components/Sidebar/Sidebar';
import CourseGrid from '../components/CourseGrid/CourseGrid';
import AISearch from '../components/Search/AISearch';
import DomainFilter from '../components/Search/DomainFilter';

// Data and hooks
import { courses } from '../data/courses';
import { useCourseFilter } from '../hooks/useCourseFilter';

const HomePage = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  
  const {
    searchTerm,
    setSearchTerm,
    selectedDomain,
    setSelectedDomain,
    filteredCourses,
  } = useCourseFilter(courses);

  const handleMenuClick = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleCourseSelect = (course) => {
    navigate(`/course/${course.id}`);
    setDrawerOpen(false);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header 
        onMenuClick={handleMenuClick}
        selectedCourse={null}
        onCourseClose={() => {}}
      />

      <Sidebar
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        courses={courses}
        onCourseSelect={handleCourseSelect}
      />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16">
        <div className="animate-fade-in">
          <AISearch
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
            onCourseSelect={handleCourseSelect}
          />
          
          <DomainFilter
            selectedDomain={selectedDomain}
            onDomainChange={setSelectedDomain}
          />

          <CourseGrid
            courses={filteredCourses}
            onCourseSelect={handleCourseSelect}
          />
        </div>
      </main>
    </div>
  );
};

export default HomePage;